import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=6f90d07e&"
import script from "./AppIcon.vue?vue&type=script&lang=js&"
export * from "./AppIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports